import styled from 'styled-components'

export const ColoredTableOuter = styled.div`
  display: grid;
  grid-template-columns: repeat(var(--columns), 1fr);
  gap: 2rem;
  @media (max-width: 40rem){
    grid-template-columns: 1fr;
  }
  small {
    font-size: 0.8em;
  }
`
export const ColoredTableItem = styled.div``
export const ColoredTableHead = styled.div`
  color: white;
  text-align: center;
  padding: 0.5rem;
  @media (max-width: 40rem){
    padding: 0.75rem 0.5rem;
  }
`
export const ColoredTableBody = styled.div`
  line-height: 1.75;
  margin-top: 0.5rem;
  font-size: 0.9rem;
`
export const ColoredTableSubject = styled.div`
  color: #96607a;
  font-weight: 700;
`